<template>
  <!-- Loading Screen -->
  <div v-if="show" class="fixed inset-0 z-50 flex items-center justify-center bg-white">
    <div class="text-center">
      <!-- Logo Animation -->
      <div class="relative w-32 h-32 mx-auto mb-8">
        <div class="absolute inset-0 bg-primary-600 rounded-lg animate-pulse"></div>
        <div class="absolute inset-2 bg-white rounded-lg flex items-center justify-center">
          <span class="text-4xl font-bold text-primary-600">艾尔</span>
        </div>
        <!-- Rotating Border -->
        <div class="absolute inset-0 border-4 border-primary-200 rounded-lg animate-spin"></div>
      </div>

      <!-- Loading Text -->
      <h2 class="text-2xl font-bold text-gray-900 mb-2">安徽艾尔工程建设</h2>
      <p class="text-gray-600 mb-6">正在加载精彩内容...</p>

      <!-- Loading Progress -->
      <div class="w-64 mx-auto">
        <div class="h-2 bg-gray-200 rounded-full overflow-hidden">
          <div 
            class="h-full bg-gradient-to-r from-primary-600 to-accent-600 rounded-full transition-all duration-300 ease-out"
            :style="{ width: progress + '%' }"
          ></div>
        </div>
        <p class="text-sm text-gray-500 mt-2">{{ progress }}%</p>
      </div>

      <!-- Loading Dots -->
      <div class="flex justify-center space-x-2 mt-8">
        <div 
          v-for="i in 3" 
          :key="i"
          class="w-3 h-3 bg-primary-600 rounded-full animate-bounce"
          :style="{ animationDelay: `${i * 0.2}s` }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

defineProps<{
  show: boolean
}>()

const progress = ref(0)

// Simulate loading progress
onMounted(() => {
  const interval = setInterval(() => {
    progress.value += Math.random() * 15
    if (progress.value >= 100) {
      progress.value = 100
      clearInterval(interval)
    }
  }, 200)
})
</script>

<style scoped>
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

.animate-spin {
  animation: spin 2s linear infinite;
}

.animate-bounce {
  animation: bounce 1.4s ease-in-out infinite both;
}
</style>